import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=e2c18e52&scoped=true&"
import script from "./publication.vue?vue&type=script&lang=js&"
export * from "./publication.vue?vue&type=script&lang=js&"
import style0 from "./publication.vue?vue&type=style&index=0&id=e2c18e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c18e52",
  null
  
)

export default component.exports